const Webforms = {
  submitFormNotify: function (_$form) {
    var formData = _$form.serialize();

    console.log('entrou aqui');

    if (!_$form.hasClass('sending')) {
      $.ajax({
        url: "/webform",
        type: 'post',
        dataType: 'json',
        data: formData,
        beforeSend: function () {
          _$form.addClass('sending');
        }
      })
        .done(function (resp) {
          //console.log("success");
          //console.info(resp);

          var msgSuccess = 'Você receberá um e-mail quando o produto estiver disponível';

          // Envia um email para o cliente saber que o usuário solicitou o avise-me
          $.ajax({
            url: '/lista_de_espera',
            type: 'POST',
            data: {
              key: _$form.find('[name="key"]').val(),
              reply_to: _$form.find('[name="email"]').val(),
              email: _$form.find('[name="email"]').val(),
              product_name: _$form.find('[name="nome"]').val(),
              referencia: _$form.find('[name="referencia"]').val(),
              sku: _$form.find('[name="sku"]').val(),
            },
          })
          .done(function (resp) {
            _$form.find("button[type=submit]").text("Enviado");
            setTimeout(function () {
              _$form.find("button[type=submit]").text("Enviar");
            }, 3500);
            _$form[0].reset();
          })
          .fail(function (error) {
            _$form.find("button[type=submit]").text("Falha ao enviar");
            setTimeout(function () {
              _$form.find("button[type=submit]").text("Enviar");
            }, 3500);
          })
          .always(function () {
          })

          if (resp.error) {
            _$form.find('.msg-response').removeClass('happy').addClass('error');
            _$form.find('.msg-response span').html(resp.error);
            _$form.find('.msg-response').slideDown(350);

            setTimeout(function () {
              _$form.find('.msg-response').removeClass('happy').removeClass('error');
              _$form.find('.msg-response span').empty();
            }, 3500);

          } else {
            _$form.find('.msg-response').addClass('happy').removeClass('error');
            _$form.find('.msg-response span').html(msgSuccess);

            setTimeout(function () {
              _$form.find('.msg-response').removeClass('happy').removeClass('error');
              _$form.find('.msg-response span').empty();
            }, 3500);

          }
        })
        .fail(function (resp) {
          //console.log("error");
          //console.error(resp);
          //console.error(resp.responseText);
          //console.error(resp.responseText.error);

          var errorText = JSON.parse(resp.responseText);
          //console.info(errorText);

          _$form.find('.msg-response').removeClass('happy');
          _$form.find('.msg-response span').html(errorText.error);
          _$form.find('.msg-response').slideDown(350);

          setTimeout(function () {
            _$form.find('.msg-response').slideUp(350);
          }, 3500);
        })
        .always(function () {
          _$form.removeClass('sending');
        });
    }
  },
  submitForm: function (_$form) {
    _$form.find('[name="reply_to"]').val(_$form.find('[name="email"]').val());

    let dataForm = _$form.serialize();
    let contentTypeForm = 'application/x-www-form-urlencoded; charset=UTF-8';
    let processDataForm = true;

    if (_$form.find('[name="interest"]').length > 0) {
      dataForm = new FormData(_$form[0]);
      
      const interests = dataForm.getAll('interest').join(' ');
      
      dataForm.delete('interest');
      dataForm.append('interest', interests)

      contentTypeForm = false;
      processDataForm = false;
    }   

    if (!_$form.hasClass('sending')) {
      $.ajax({
        url: '/webform',
        type: 'POST',
        data: dataForm,
        processData: processDataForm,
        contentType: contentTypeForm,
        beforeSend: function () {
          _$form.addClass('sending');

          _$form.find('button[type="submit"]').text('ENVIANDO...');
        }
      })
      .done(function() {
        // console.info('foi');
        // store.setMsgResponse('Mensagem enviada com sucesso!', 'success', _$form);
        _$form.find('[data-msg-retorno] [data-msg-success]').addClass('visible');
        _$form.find('[data-msg-retorno] [data-msg-error]').removeClass('visible');

        _$form.find('button[type="submit"]').text('ENVIADO!');
        _$form.find('button[type="submit"]').addClass('sent');


        _$form[0].reset();
      })
      .fail(function() {
        // console.info('foi, mas deu ruim');
        _$form.find('[data-msg-retorno] [data-msg-success]').removeClass('visible');
        _$form.find('[data-msg-retorno] [data-msg-error]').addClass('visible');

        _$form.find('button[type="submit"]').text('FALHA AO ENVIAR');

        // store.setMsgResponse('Houve um problema ao enviar sua mensagem, tente novamente! Ou entre em contato conosco pelo telefone (21) 99644-6925 ', 'error', $form);
      })
      .always(function(resp) {
        //console.log("complete");
        /* console.log(resp); */
        _$form.removeClass('sending');
      });
    }
  },
  init: function(){
    // ENVIO DE FORMULÁRIOS
    $('[data-webform]').on('submit', function (event) {
      event.preventDefault();
      var $form = $(this);

      var honeyPot = $(this).find('[name="vnda"]');

      if (honeyPot.length > 0) {
        if (honeyPot.val() != '') {
          //console.info('ROBOT DETECTED');
          return false;
        }
      }

      var formNotify = $form.find('#email-notify-when-arrives');

      if (formNotify.length >= 1) {
        Webforms.submitFormNotify($(this));
      } else {
        Webforms.submitForm($(this));
      }
    });
  }
}

export default Webforms;
